export const DEBOUNCE_TIME = 250;
export const MIN_CHARACTERS_TO_SEARCH = 3;
export const MAX_CHARACTERS_TO_SEARCH = 255;
export const OFFSET_ITEM_HEIGHT = 30;
export const DISPLAY_NAME_LIMIT = 10;
export const ISSUES_GRID_KEY = 'issues-grid';
export const ISSUE_TYPES_GRID_KEY = 'categories-grid';
export const SORT_DIRECTION_ASC = 'ASC';
export const SORT_DIRECTION_DESC = 'DESC';
export const DEFAULT_GRID_PAGE = 0;
export const DEFAULT_GRID_PAGE_SIZE = 10;
export const DEFAULT_PAGINATION_STATE = {
  currentPage: DEFAULT_GRID_PAGE,
  pageSize: DEFAULT_GRID_PAGE_SIZE,
  total: 0,
};
